export default "__VITE_ASSET__C6Ax9eSB__"